var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDestinyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 70,
    viewBox: "0 0 78 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1078 30.5686C59.6068 30.093 58.2042 28.6662 57.7033 28.1706C53.8922 24.3698 48.6064 19.0343 44.8995 15.2495L41.7015 11.9883C41.2742 11.4076 40.7204 10.9312 40.0818 10.5947C39.4432 10.2583 38.7365 10.0706 38.0147 10.0459C37.0224 10.052 36.0692 10.4318 35.3457 11.109L32.0596 14.2384C28.2084 17.9632 22.6982 23.1348 18.8109 26.7118C18.306 27.2234 15.1161 30.069 14.6873 30.5766C14.016 31.4134 13.5988 32.4244 13.4851 33.4901C13.4832 33.502 13.4832 33.5141 13.4851 33.5261L14.3426 32.9745L14.4669 32.8986C22.0209 28.0267 30.3644 22.3955 37.8664 17.6715L38.3954 17.3318L38.9765 17.6914C44.5228 21.1325 52.0327 25.9645 57.5189 29.5015L61.1738 31.8995C60.9113 31.3891 60.5488 30.9366 60.1078 30.5686Z",
    fill: "url(#paint0_linear_132_5804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2143 35.8643L14.7032 36.3518C21.3235 32.8588 31.2059 27.907 37.9063 24.5978L38.3712 24.366L38.8922 24.6098C42.1903 26.1125 47.2758 28.6064 50.5779 30.1691C54.1045 31.8597 57.607 33.6022 61.1215 35.3207C61.1338 35.3016 61.1445 35.2816 61.1536 35.2608L55.9719 31.8157C50.2934 28.0429 43.9496 23.7945 38.3391 19.8738C31.0536 24.0303 20.6302 29.8374 13.4929 33.6341C13.5648 34.4216 13.8112 35.1833 14.2143 35.8643Z",
    fill: "url(#paint1_linear_132_5804)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3432 26.8438C31.0937 30.0011 22.8304 33.3543 15.5007 36.4356L14.9878 36.6515L19.7566 41.4074L20.4299 42.0269C25.3951 38.8856 32.853 34.5053 37.8303 31.4918L38.3873 31.1601L39.0125 31.5158C44.4907 34.6931 49.9208 37.9544 55.3389 41.2396L55.435 41.2995C56.521 40.2005 57.9798 38.7457 59.186 37.5427L59.0938 37.4948C52.213 34.0377 45.0918 30.4407 38.3432 26.8438Z",
    fill: "url(#paint2_linear_132_5804)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8066 42.4309L20.8307 42.4549L22.1572 41.7075C21.6963 41.9553 21.2435 42.1911 20.8066 42.4309Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0707 38.2899L38.3673 38.146L38.7159 38.2979L52.3413 44.1849L52.5297 44.2649L53.4353 43.3057L53.3231 43.2297L38.3593 33.3621C33.5103 35.8719 27.2106 39.0572 22.1772 41.723C21.7163 41.9708 21.2635 42.2066 20.8267 42.4464L20.8507 42.4704L23.7 45.312L38.0707 38.2899Z",
    fill: "url(#paint3_linear_132_5804)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6385 45.368C45.3163 43.7693 41.6335 41.9189 38.3273 40.2043C33.7588 42.0308 28.7415 43.7054 24.1209 45.4639L23.9165 45.5398L25.2831 46.9027L25.4714 47.0266C29.6311 45.32 34.1475 43.5895 38.3353 42.0228C41.8298 43.1232 45.3136 44.2596 48.7868 45.4319L48.6385 45.368Z",
    fill: "url(#paint4_linear_132_5804)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80894 55.4358C8.49981 55.4358 10.4635 57.7339 10.4635 61.119C10.4635 64.5041 8.49981 66.7822 4.80894 66.7822H0V55.4358H4.80894ZM8.64408 61.119C8.64408 58.5851 7.4779 57.0145 4.54845 57.0145H1.74323V65.2115H4.54845C7.4779 65.2115 8.64408 63.6888 8.64408 61.135",
    fill: "#292978"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3856 66.7822H13.95V55.4358H22.2093V57.0344H15.7092V60.1598H21.3277V61.7545H15.7092V65.1875H22.3856V66.7822Z",
    fill: "#292978"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.829 55.887L32.6768 57.5496C31.7101 57.0847 30.6481 56.8507 29.575 56.8662C28.0842 56.8662 27.1144 57.3738 27.1144 58.4649C27.1144 59.6639 28.0441 59.8277 28.9498 60.0955L30.6169 60.5871C32.2921 61.0787 33.3701 61.842 33.3701 63.5206C33.3701 65.4749 31.703 66.9377 29.2744 66.9377C27.7356 66.9377 25.9763 66.602 25.1548 66.1384L25.3031 64.5397C26.4994 65.0373 27.7782 65.3083 29.0741 65.3391C30.4406 65.3391 31.4785 64.7516 31.4785 63.6645C31.4785 62.7572 30.9936 62.3896 29.8756 62.0658L28.0762 61.5702C26.7297 61.1706 25.2469 60.4592 25.2469 58.7047C25.2469 56.6304 26.7618 55.2676 29.3826 55.2676C30.5661 55.2483 31.7421 55.4587 32.8451 55.887",
    fill: "#292978"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.137 57.0824H35.374V55.4358H44.6312V57.0824H40.8883V66.7822H39.137V57.0824Z",
    fill: "#292978"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3198 55.4358H47.5605V66.7822H49.3198V55.4358Z",
    fill: "#292978"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2307 66.7822H53.4714V55.4358H55.2307L62.4962 64.0845V55.4358H64.2555V66.7822H62.4802L55.2307 58.2174V66.7822Z",
    fill: "#292978"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6808 55.4358H77.7767L73.2924 62.4219V66.7822H71.5411V62.4219L67.0608 55.4358H69.1567L72.4147 60.6434L75.6808 55.4358Z",
    fill: "#292978"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_132_5804",
    x1: 13.469,
    y1: 21.788,
    x2: 61.1577,
    y2: 21.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3017F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_132_5804",
    x1: 13.5009,
    y1: 28.1148,
    x2: 61.1536,
    y2: 28.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3017F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_132_5804",
    x1: 14.9718,
    y1: 34.4134,
    x2: 59.17,
    y2: 34.4134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B876AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_132_5804",
    x1: 20.8066,
    y1: 39.329,
    x2: 53.4313,
    y2: 39.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_132_5804",
    x1: 23.9165,
    y1: 43.6215,
    x2: 48.7988,
    y2: 43.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292978"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinyLogo);
export default __webpack_public_path__ + "static/media/destiny-logo.ea3b204383e8fa511e4814d507dd8502.svg";
export { ForwardRef as ReactComponent };